/** The fields of the booking modals (a list, a text): white, thin border, primary when focused. */
export const HOME_BOOKING_FIELD =
  'form-input w-full rounded-md border-neutral-30 py-1.5 text-body-s text-neutral-140 focus:border-primary-100 focus:ring-primary-100';
